import React, { cloneElement, useEffect, useRef, useState } from "react";
const MAX_ATTEMPTS = 3;

export const PseudoContent = ({ children }) => {
  const elementRef = useRef(null);
  const [pseudoContent, setPseudoContent] = useState("");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    const element = elementRef.current;
    if (element) {
      const content = window
        .getComputedStyle(element, "::before")
        .getPropertyValue("content");
      if (content && content !== "none") {
        setPseudoContent(content);
      } else {
        setPseudoContent(`none ${attempt}`);
      }
    }
  }, [elementRef.current, attempt]);

  useEffect(() => {
    const element = elementRef.current;
    if (element && pseudoContent && !pseudoContent.includes("none")) {
      element.innerHTML = pseudoContent.slice(1, -1);
    } else {
      if (attempt < MAX_ATTEMPTS) {
        setAttempt(attempt + 1);
      } else if (attempt < 3 + MAX_ATTEMPTS) {
        setTimeout(() => {
          setAttempt(MAX_ATTEMPTS + 1);
        }, 1000);
      }
    }
  }, [pseudoContent]);

  const attachRefToChild = (child) => {
    if (React.isValidElement(child)) {
      if (
        child.props.className &&
        (child.props.className.includes("pageFooterText") ||
          child.props.className.includes("pageHeaderText"))
      ) {
        return cloneElement(child, { ref: elementRef });
      }
      if (child.props.children) {
        return cloneElement(child, {
          children: React.Children.map(child.props.children, attachRefToChild),
        });
      }
    }
    return child;
  };

  const childWithRef = React.Children.map(children, attachRefToChild);

  return <div>{childWithRef}</div>;
};
